type StoreCardDetailsA11yParts = {
  title?: string | null;
  address?: string | null;
  addressAccessibilityLabel?: string | null;
  availability?: string;
  body?: string;
  errorMessage?: string | null;
  isSelected?: boolean;
};

/** Keeps native/web store card disclosure announcements aligned. */
export const buildStoreCardDetailsAccessibilityLabel = ({
  title,
  address,
  addressAccessibilityLabel,
  availability,
  body,
  errorMessage,
  isSelected,
}: StoreCardDetailsA11yParts): string =>
  [
    isSelected ? 'Selected' : undefined,
    title,
    addressAccessibilityLabel ?? address,
    availability,
    body,
    errorMessage,
  ]
    .filter(part => Boolean(part && String(part).trim()))
    .join(', ');
